import {
    PsHttpService,
    type PatSnapCommonResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { isUserLogin } from '@eureka/utils/account';

export interface NerNorRequest {
    content: string
    structure_enabled?: boolean
    embodiment_enabled?: boolean
    sequence_enabled?: boolean
    patent_id?: string
}

export interface NerNorDTO {
    data_type: string
    original_name: string
    start_index: number
    end_index: number
    normalized_id: string
    smiles?: string
    url?: string
    pn?: string
    sequence?: string
    sequence_no?: number
    patent_link?: string
}

export interface NerNorApi {
    nerNorAll(data: NerNorRequest): Promise<NerNorDTO[]>;
}

export const NerNorApi = Symbol('NerNorApi');

@injectable()
export class NerNorApiImpl extends PsHttpService implements NerNorApi {
    get baseUrl() {
        return `${import.meta.env.VITE_EUREKA_SERVICE_URI}/core-eurekals-api/eurekals_agent/1.0`
    }

    get options() {
        return {
            baseURL: this.baseUrl,
        };
    }

    async nerNorAll(data: NerNorRequest) {
        const isLogin = await isUserLogin()
        const base = isLogin ? '' : '/guest'
        return this.post<PatSnapCommonResponseData<NerNorDTO[]>>({
            url: `${base}/ner-nor`,
            data,
        }).then((res) => {
            return res as unknown as NerNorDTO[];
        });
    }
}
